import { combineReducers } from "@reduxjs/toolkit";
import { reducer as ecommerceViewLabTransactionReducer } from "../slices/ecommerce-view-lab-transaction";
import getStreamReducer from "../slices/getstream-slice";

const rootReducer = combineReducers({
  ecommerceViewLabTransaction: ecommerceViewLabTransactionReducer,
  getStreamToken: getStreamReducer,
});

export default rootReducer;
